(function() {
  define('bazemont/resources/NewsletterPreferences',['angular', 'angularResource'], function() {
    'use strict';
    return angular.module('NewsletterPreferencesResource', ['ngResource']).factory('NewsletterPreferences', [
      '$resource', function($resource) {
        return $resource('/api/user/newsletter-preferences');
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=NewsletterPreferences.js.map
;
